"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/WSFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_251)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_251`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.07996 0H34.9201V24.0003H-1.07996V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.07996 0H16.9201V11.9998H-1.07996V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.5555 6.78211L10.7499 7.38005H11.3784L10.8699 7.74947L11.0642 8.34734L10.5555 7.97785L10.047 8.34734L10.2412 7.74947L9.73266 7.38005H10.3613L10.5555 6.78211ZM7.39821 2.08643L7.72207 3.08297H8.76973L7.92211 3.69869L8.2459 4.69509L7.39821 4.0793L6.55067 4.69509L6.87445 3.69869L6.02677 3.08297H7.07449L7.39821 2.08643ZM10.5287 3.12993L10.8525 4.1264H11.9002L11.0526 4.74213L11.3763 5.73867L10.5287 5.12273L9.68112 5.73867L10.0048 4.74213L9.15722 4.1264H10.2049L10.5287 3.12993ZM8.05423 7.3039L8.37809 8.30037H9.42575L8.57813 8.91617L8.90185 9.91257L8.05423 9.2967L7.20668 9.91257L7.5304 8.91617L6.68278 8.30037H7.73044L8.05423 7.3039ZM5.31134 4.69509L5.63513 5.69163H6.68278L5.83517 6.30736L6.15888 7.3039L5.31134 6.68796L4.46372 7.3039L4.78744 6.30736L3.93982 5.69163H4.98748L5.31134 4.69509Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_251`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as WSFlag };
